const algoliasearch = require('algoliasearch/lite')
const instantsearch = require('instantsearch.js').default

import catalogRouting from '../widgets/algolia/CatalogRouting'

import {
  catalogConfigure,
  catalogHits,
  catalogCategories,
  catalogModality,
  catalogSolutions,
  catalogTaskGroup,
  catalogCurrentRefinements,
  catalogProductCategoryGroup,
} from '../widgets'

export default class AlgoliaCatalog {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.appId = window.agI
    this.apiKey = window.agSk
    this.index = window.agSc
    this.env = window.Environment
  }

  init() {
    if (!this.check()) {
      return false
    }

    // only log analytics if in production
    const analytics = this.env === 'production'
    const searchClient = algoliasearch(this.appId, this.apiKey)

    const search = instantsearch({
      indexName: this.index,
      analytics,
      searchClient,
      routing: catalogRouting,
    })

    search.addWidgets([
      catalogConfigure,
      catalogHits,
      catalogCategories,
      catalogModality,
      catalogSolutions,
      catalogTaskGroup,
      catalogProductCategoryGroup,
      catalogCurrentRefinements,
    ])
    search.start()
  }

  check() {
    return true
  }
}
